import { Box, Drawer, IconButton, Modal } from "@mui/material";
import { NeutralColor } from "node-library/dist/colors";
import CloseIcon from "@mui/icons-material/Close";
import { CustomIconButton } from "../button";

interface DrawerProp {
	headerText: string;
	headerDescription?: string;
	open: boolean;
	setOpen: (open: boolean) => void;
	anchor: "right" | "left" | "top" | "bottom" | undefined;
	children: React.ReactNode;
	drawerWidth?: number | string;
}

function CustomDrawer(props: DrawerProp) {
	const modelStyle = {
		// bgcolor: "background.paper",
		width: props.drawerWidth || 500,

		// borderRadius: "24px",
		// boxShadow: 24,
		p: 4,
		"@media (max-width: 600px)": {
			width: "100%", // Set width to 90% for mobile screens
		},
	};
	return (
		<Drawer
			anchor={props.anchor}
			open={props.open}
			sx={{
				"& .MuiDrawer-paper": {
					// This is the key: set the paper width
					width: props.drawerWidth || 500,
					boxSizing: "border-box",
				},
				"@media (max-width: 600px)": {
					width: "100%", // Set width to 90% for mobile screens
					"& .MuiDrawer-paper": {
						width: "100%", // Make sure the paper inside the drawer also takes 100% width
					},
				},
			}}
			onClose={() => props.setOpen(false)}
		>
			<Box sx={modelStyle}>
				<div className="modal-header">
					<div className="modal-header-text-container">
						<div className="typography-heading-03 overflow-ellipsis-text">
							{props.headerText}
						</div>
						{props.headerDescription && (
							<div
								className="typography-caption"
								style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
							>
								{props.headerDescription}
							</div>
						)}
					</div>
					<CustomIconButton
						onClick={() => props.setOpen(false)}
						icon={<CloseIcon />}
						size="medium"
						id={"drawer-close-button"}
						// sx={{
						// 	color: NeutralColor.NEUTRAL_GREY_950,
						// 	width: "32px",
						// 	height: "32px",
						// 	minWidth: "32px",
						// 	minHeight: "32px",
						// 	borderRadius: "50%", // Make the button round
						// 	"&:hover": {
						// 		bgcolor: NeutralColor.NEUTRAL_GREY_950,
						// 		color: "white",
						// 	},
						// }}
					></CustomIconButton>
				</div>
				<div className="modal-body">{props.children}</div>
			</Box>
		</Drawer>
	);
}

export { CustomDrawer };
